<template>
  <button class="block-btn md-btn wish-btn" @click="addWish">위시리스트 저장</button>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'add-wish-btn',
    props: ['lectureId'],
    methods: {
      addWish() {
        axios.post(`/api/lectures/${this.lectureId}/wish`, null).then(() => {
          alert('위시리스트에 저장하였습니다.');
        }).catch(() => {
          alert('위시리스트에 저장할 수 없습니다.');
        });
      },
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// AddWishButton.vue?f35261d6